<template>
  <a
    class="category-overview-teaser"
    :class="{'category-overview-teaser__simple': !text}"
    :href="link && link.url ? link.url : false"
    :target="link && link.openInNewWindow ? '_blank' : ''"
  >
    <img
      class="category-overview-teaser__img"
      :src="image.src"
      :alt="image.alt"
      :title="image.title"
      :width="image.width"
      :height="image.height"
      loading="lazy"
    >
    <div
      class="category-overview-teaser__content"
    >
      <span
        class="category-overview-teaser__headline"
        :class="[
          headlineBgColor ? headlineBgColor : null,
          textColor ? textColor : null
        ]"
        v-html="headline"
      />
      <span
        class="category-overview-teaser__text"
        :class="[
          sublineColor ? sublineColor : null,
          textBgColor ? textBgColor : null
        ]"
        v-html="text"
      />
    </div>

  </a>
</template>

<script>
  export default {
    props: {
      headline: {
        type: String
      },
      text: {
        type: String
      },
      link: {
        type: Object
      },
      image: {
        type: Object
      },
      headlineBgColor: {
        type: String
      },
      textColor: {
        type: String
      },
      sublineColor: {
        type: String
      },
      textBgColor: {
        type: String
      }
    }
  };

</script>
